module.exports = __webpack_public_path__ + "9939f542394ce23f423e81585e454f6f.pdf";